import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentConfigService } from '../../core/config/environment-config.service';
import { AuthenticationService } from '../authentication/authentication.service';

export interface StripePaymentMethodCard {
  brand?: string;
  last4?: string;
  exp_month?: number;
  exp_year?: number;
}

export interface StripePaymentMethod {
  id?: string;
  type?: string;
  card?: StripePaymentMethodCard;
  [key: string]: any;
}

export interface StripeSubscriptionItemPrice {
  id?: string;
  nickname?: string;
  unit_amount?: number;
  currency?: string;
  recurring?: { interval?: string; interval_count?: number };
  product?: string;
  [key: string]: any;
}

export interface StripeSubscriptionItem {
  id?: string;
  price?: StripeSubscriptionItemPrice;
  [key: string]: any;
}

export interface StripeSubscription {
  id?: string;
  status?: string;
  current_period_start: number;
  current_period_end: number;
  cancel_at?: boolean;
  trial_days_left: number;
  items?: { data?: StripeSubscriptionItem[] } | any;
  [key: string]: any;
}

export interface StripeUserResponse {
  customer?: any;
  subscriptions?: StripeSubscription[];
  paymentMethods?: StripePaymentMethod[];
}

@Injectable({ providedIn: 'root' })
export class StripeService {
  private headers = new HttpHeaders()
    .set('content-type', 'application/json');

  constructor(
    private http: HttpClient,
    private env: EnvironmentConfigService,
    private auth: AuthenticationService
  ) {}

  getUserStripe(): Observable<StripeUserResponse> {
    return new Observable<StripeUserResponse>((observer) => {
      this.auth.getIdToken().then((idToken) => {
        if (!idToken) {
          observer.error(new Error('ID token is undefined'));
          return;
        }
        let httpHeaders = new HttpHeaders()
          .set('Content-Type', 'application/json')
          .set('Authorization', idToken);
        this.http
          .get<StripeUserResponse>(`${this.env.apiUrl}/stripe/user`, {headers: httpHeaders})
          .subscribe({
            next: (data) => {
              observer.next(data);
              observer.complete();
            },
            error: (err) => {
              console.log(err);
              observer.error(err);
            },
          });
      }).catch((err) => observer.error(err));
    });
  }

  // Request Stripe customer portal/checkout URL and return it
  createOrGetStripePortal(): Observable<{ url: string }> {
    return new Observable<{ url: string }>((observer) => {
      this.auth.getIdToken().then((idToken) => {
        if (!idToken) {
          observer.error(new Error('ID token is undefined'));
          return;
        }
        let httpHeaders = new HttpHeaders()
          .set('Content-Type', 'application/json')
          .set('Authorization', idToken);
        const callbackUrl = `${window.location.origin}/usuario`;
        this.http
          .post<{ url: string }>(
            `${this.env.apiUrl}/stripe/edit-credit-card`,
            { callbackUrl, returnUrl: callbackUrl },
            {headers: httpHeaders}
          )
          .subscribe({
            next: (data) => {
              console.log('StripeService: Stripe portal URL:', data);
              observer.next(data);
              observer.complete();
            },
            error: (err) => observer.error(err),
          });
      }).catch((err) => observer.error(err));
    });
  }


}
